<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>

  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>

    <div class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2 sp-company-details__grid">
      <app-company-details-header
        [company_id]="company_id"
        (tab_change)="onTabChange($event)"
        (refresh)="onRefresh()"></app-company-details-header>

      <app-company-details-general
        *ngIf="current_tab === tabs.get('article')"
        [company_id]="company_id"
        (refresh)="onRefresh()"></app-company-details-general>

      <app-company-details-store-data
        *ngIf="current_tab === tabs.get('storefront')"
        [company_id]="company_id"></app-company-details-store-data>

      <app-company-details-team-data
        *ngIf="current_tab === tabs.get('group')"
        [company_id]="company_id"></app-company-details-team-data>

      <app-company-details-order-data
        *ngIf="current_tab === tabs.get('receipt_long')"
        [company_id]="company_id"></app-company-details-order-data>

      <app-company-details-unpaid-data
        *ngIf="current_tab === tabs.get('money_off')"
        [company_id]="company_id"
        (refresh)="onRefresh()"></app-company-details-unpaid-data>

      <app-company-details-event-data
        *ngIf="current_tab === tabs.get('timeline')"
        [company_id]="company_id"></app-company-details-event-data>

      <app-company-details-pending-invitations-data
        *ngIf="current_tab === tabs.get('mail_outline')"
        [company_id]="company_id"></app-company-details-pending-invitations-data>
    </div>
  </div>
</div>
